import React, { useEffect, useRef, useState, useMemo } from 'react';
import { Stack } from "@carbon/react";
import Card from '../../components/Layouts/Card'
import Typography from "../../components/Basics/Typography";
import { Map } from "@carbon/icons-react";
import SimpleCesiumFallback from "../../components/TruckMap3D";
import { AppContainer } from "../Monitoring/Map/MonitoringMap.styles";
import MapControls from "./MapControls"; // ⬅️ new import
import useMapEligibility from '../../config/store/hooks';
import MapBlocker from './MapBlocker'

const CesiumV2 = () => {
    const [trucks, setTrucks] = useState([]);
    const [checkNonce, setCheckNonce] = useState(0); // to allow "Reintentar"
    const { ok, missing, hints } = useMapEligibility();

    // same filters shape as your other map
    const [filters, setFilters] = useState({
        patentes: [],
        time_categories: [],
        types: [],
    });

    const minutesSince = (d) => (Date.now() - d.getTime()) / 60000;

    const getTimeCategory = (ts) => {
        const d = ts ? new Date(ts) : null;
        const diff = d && !isNaN(d) ? minutesSince(d) : Infinity;
        if (diff <= 15) return 'Operativo';
        if (diff <= 120) return 'Dato > 15 min';
        return 'Dato > 120 min';
    };

    // === Fetch trucks from your API ===
    const fetchTruckData = async () => {
        try {
            const auth = btoa(`${process.env.REACT_APP_USER}:${process.env.REACT_APP_PASS}`);
            const header = `Basic ${auth}`;
            const endpoint = process.env.REACT_APP_DATA_ENDPOINT;

            if (!endpoint) {
                console.warn('Missing REACT_APP_DATA_ENDPOINT');
                return;
            }

            const res = await fetch(endpoint, {
                method: 'GET',
                headers: { Authorization: header },
            });

            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            const data = await res.json();

            // Adapt trucks
            const adapted = data.map((t, idx) => ({
                id: t.device_id || `truck-${idx}`,
                name: t.truckPatent || t.marca || `Truck ${idx}`,
                lat: Number(t.lat),
                lon: Number(t.lon),
                altitude: 2400,
                speed: Number(t.velocidad) || 0, // km/h
                driver: t.operador || 'Sin Operador',
                brand: t.marca,
                model: t.modelo,
                lastUpdate: t.currTime,
                heading: Number(t.head) || 0, // degrees, 0=N, 90=E
                timeCategory: getTimeCategory(t.currTime),
            }));

            setTrucks(adapted);
        } catch (err) {
            console.error('Fetch error:', err);
        }
    };

    useEffect(() => {
        fetchTruckData();
        const interval = setInterval(fetchTruckData, 60000); // every 1 min
        return () => clearInterval(interval);
    }, []);

    // Build items for MapControls (shape matches your previous map)
    const controlItems = useMemo(
        () =>
            trucks.map((t) => ({
                properties: {
                    truckPatent: String(t.name ?? ""),
                    time_category: String(t.timeCategory ?? ''),  // NEW
                    type: String(t.brand ?? t.model ?? "—"),
                },
            })),
        [trucks]
    );

    const filteredTrucks = useMemo(() => {
        return trucks.filter((t) => {
            const patenteOk =
                filters.patentes.length > 0
                    ? filters.patentes.includes(String(t.name))
                    : true;

            const stateOk =
                filters.time_categories.length > 0 ? filters.time_categories.includes(String(t.timeCategory)) : true;


            const typeVal = String(t.brand ?? t.model ?? "—");
            const typeOk =
                filters.types.length > 0 ? filters.types.includes(typeVal) : true;

            return patenteOk && stateOk && typeOk;
        });
    }, [trucks, filters]);

    return (
        <Stack gap={3}>
            <Card justifyContent='flex-start' >
                <Map size={18} />
                <Typography className='cds--type-heading-compact-01'>
                    MAPA - TIEMPO REAL
                </Typography>
            </Card>
      {!ok ? (
        <>
          <MapBlocker
            key={checkNonce}
            missing={missing}
            hints={hints}
            onRetry={() => setCheckNonce((n) => n + 1)}
          />
        </>
      ) : (
        <>
          <Card>
            <AppContainer>
              <MapControls
                allItems={controlItems}
                filters={filters}
                setFilters={setFilters}
              />
            </AppContainer>
          </Card>
          <Card>
            <AppContainer>
              <SimpleCesiumFallback trucks={filteredTrucks} />
            </AppContainer>
          </Card>
        </>
      )}
        </Stack>
    )
}

export default CesiumV2;